import { useState } from "react";
import { colors } from "../../../global";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompress, faExpand, faX } from "@fortawesome/free-solid-svg-icons";
import DataTableComponent from "../../../shared/components/DataTableComponent";

function DetailModal({ file, closeModal, title = "Preview Data" }) {
  const [isFullScreen, setIsFullScreen] = useState(false);

  var columns = [];
  var data = [];

  if (title === "Minor Error Data") {
    columns = ["Consignment ID", "Dispatch Date", "Description"];
    data = [
      [
        "1",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["2", "25 June 2022", "<p>• Missing Reciever Name</p>"],
      [
        "3",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever DG Status</p>"],
      ["12312", "25 June 2022", "<p>• Missing Reciever Name</p>"],
      [
        "1",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["2", "25 June 2022", "<p>• Missing Reciever Name</p>"],
      [
        "3",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever DG Status</p>"],
      ["12312", "25 June 2022", "<p>• Missing Reciever Name</p>"],
      [
        "1",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["2", "25 June 2022", "<p>• Missing Reciever Name</p>"],
      [
        "3",
        "25 June 2022",
        "<p>• Missing Reciever Name<br />• Missing Reciever DG Status</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever DG Status</p>"],
      ["12312", "25 June 2022", "<p>• Missing Reciever Name</p>"],
    ];
  }
  if (title === "Major Error Data") {
    columns = ["Consignment ID", "Dispatch Date", "Description"];
    data = [
      [
        "1",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "2",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "3",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever To State</p>"],
      ["12312", "25 June 2022", "<p>• Missing From State</p>"],
      [
        "1",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "2",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "3",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever To State</p>"],
      ["12312", "25 June 2022", "<p>• Missing From State</p>"],
      [
        "1",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "2",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      [
        "3",
        "25 June 2022",
        "<p>• Missing From State<br />• Missing Reciever To State</p>",
      ],
      ["4142", "25 June 2022", "<p>• Missing Reciever To State</p>"],
      ["12312", "25 June 2022", "<p>• Missing From State</p>"],
    ];
  }

  if (title === "Duplicated Data") {
    columns = ["Consignment ID", "Dispatch Date", "Description"];
    data = [
      ["1", "25 June 2022", "<p>• Row 11<br />• Row 23</p>"],
      ["2", "25 June 2022", "<p>• Row 32<br />• Row 41</p>"],
      ["3", "25 June 2022", "<p>• Row 54<br />• Row 98</p>"],
      ["4142", "25 June 2022", "<p>• Row 88<br />• Row 76</p>"],
      ["12312", "25 June 2022", "<p>• Row 10<br />• Row 54</p>"],
      ["1", "25 June 2022", "<p>• Row 11<br />• Row 23</p>"],
      ["2", "25 June 2022", "<p>• Row 32<br />• Row 41</p>"],
      ["3", "25 June 2022", "<p>• Row 54<br />• Row 98</p>"],
      ["4142", "25 June 2022", "<p>• Row 88<br />• Row 76</p>"],
      ["12312", "25 June 2022", "<p>• Row 10<br />• Row 54</p>"],
      ["1", "25 June 2022", "<p>• Row 11<br />• Row 23</p>"],
      ["2", "25 June 2022", "<p>• Row 32<br />• Row 41</p>"],
      ["3", "25 June 2022", "<p>• Row 54<br />• Row 98</p>"],
      ["4142", "25 June 2022", "<p>• Row 88<br />• Row 76</p>"],
      ["12312", "25 June 2022", "<p>• Row 10<br />• Row 54</p>"],
    ];
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div
        className={`bg-white rounded-lg shadow-2xl transition-all duration-300 ${
          isFullScreen
            ? "w-full h-full rounded-none m-0"
            : "w-full max-w-6xl max-h-full"
        }`}
        style={{ backgroundColor: colors.white }}
      >
        {/* Modal Header */}
        <div
          className="flex justify-between items-center p-6 border-b-2 rounded-t-lg"
          style={{
            backgroundColor: colors.primary,
            borderColor: colors.secondary,
          }}
        >
          <div className="flex items-center space-x-3">
            <div>
              <h2 className="text-xl font-bold text-white">{title}</h2>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <button
              onClick={() => setIsFullScreen(!isFullScreen)}
              className="flex items-center space-x-2 px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-lg transition-all duration-200 font-medium"
            >
              <FontAwesomeIcon icon={isFullScreen ? faCompress : faExpand} />
              <span className="hidden sm:inline">
                {isFullScreen ? "Exit Full Screen" : "Full Screen"}
              </span>
            </button>
            <button
              onClick={closeModal}
              className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-lg transition-all duration-200"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faX} />
            </button>
          </div>
        </div>

        <div className="p-6">
          <DataTableComponent
            columns={columns}
            data={data}
            options={{
              scrollX: true,
              scrollY: "600px",
              scrollCollapse: true,
              paging: true,
              fixedColumns: {
                leftColumns: 3,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DetailModal;
